import { VIDEO_TILE_WIDTH } from '@/components/VideoTile';
import { ICampaign } from '@d-id/types';
import styled from '@emotion/styled';
import { CampaignTile } from '../CampaignsTile';

const TilesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${VIDEO_TILE_WIDTH}px, 1fr));
    grid-row: 1; /* Ensure each row takes up equal height */
    grid-gap: 24px;
    overflow: hidden;
    justify-content: space-between;
`;

const LibraryContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const SectionTitle = styled.h2`
    color: ${({ theme }) => theme.colors.black[700]};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.32px;
`;

interface CampaignsListProps {
    campaigns: ICampaign[];
    title: string;
    openAssetsModal: (campaign: ICampaign) => void;
    openCreditsCalculatorModal: (campaign: ICampaign) => void;
}
export const CampaignsList = ({ campaigns, title, openAssetsModal, openCreditsCalculatorModal }: CampaignsListProps) => {
    if (!campaigns.length) {
        return null;
    }

    return (
        <LibraryContainer>
            <SectionTitle>{title}</SectionTitle>

            <TilesContainer>
                {campaigns.map(campaign => (
                    <CampaignTile
                        campaign={campaign}
                        key={campaign.id}
                        openAssetsModal={() => openAssetsModal(campaign)}
                        openCreditsCalculatorModal={() => openCreditsCalculatorModal(campaign)}
                    />
                ))}
            </TilesContainer>
        </LibraryContainer>
    );
};
